<template>
  <main id="main">
    <div class="l-contents">
      <h1 class="l-pageTitle">入力受付完了</h1>
      <div class="l-contentsBox">
        <div class="l-infoDetail">
          <div class="l-infoDetail__body">
            <div class="l-infoDetail__box">
              <div class="l-infoDetail__text">
                <p>お問い合わせを受け付けました。内容確認後にご連絡いたします。</p>
                <p>トライアルをお申込みの場合、入力いただいたメールアドレスに確認用のメールを送信しております。受信BOXをご確認ください。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created: function() {
    this.$store.dispatch('contactForm/init');
  }
}
</script>